/*
Licensed Materials - Property of IBM
694906H
(c) Copyright IBM Corp.  2020 All Rights Reserved

US Government Users Restricted Rights - Use, duplication or disclosure restricted
by GSA ADP Schedule Contract with IBM Corp.
*/

import styled from 'styled-components';
import theme from './FormTop.theme';

export const FormTop = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
`;

export const FormTitle = styled.h1`
  color: ${props => theme(props).colorPurple};
  font-size: 1rem;
  font-weight: 600;
  letter-spacing: 0.0112rem;
  line-height: 1.375rem;
`;

export const FormSubtitle = styled.div`
  color: ${props => theme(props).colorPurple};
  font-size: 0.75rem;
  font-weight: 500;
  letter-spacing: 0.0088rem;
  line-height: 1.0625rem;
`;
